module.exports = __webpack_public_path__ + "media/application/images/svgs/hexagon-11745ab852592ef7d5b1e2a190321087.svg";